module.exports = __webpack_public_path__ + "static/img/pic_sfz@2x.90581dc6.png";